import ZoomBlock from './ZoomBlock';

export default ZoomBlock;
